import { type FC, useContext } from 'react';

import { Toast } from '../Toast';

import { ToastStateContext, ToastDispatchContext } from './context';

const Toasts: FC = () => {
    const dispatch = useContext(ToastDispatchContext);
    const { toasts } = useContext(ToastStateContext);

    return (
        <>
            {toasts.map(({ id, children, onClose, ...props }) => (
                <Toast
                    key={id}
                    {...props}
                    onClose={() => {
                        onClose?.();
                        dispatch({ type: 'REMOVE_TOAST', id });
                    }}
                >
                    {children}
                </Toast>
            ))}
        </>
    );
};

export { Toasts };
